import { ChangeDetectorRef, Component, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants, WarmUpService } from 'app/services/warmup/warmup.service';
import { Document } from 'app/shared/models/document.model';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { User } from 'app/shared/models/user.model';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';


@Component({
  selector: 'add-document',
  templateUrl: './add-document.component.html',
  styleUrls: ['./add-document.component.css']
})
/**
 * Component to add a document for agreement.
 */
export class AddDocumentComponent implements OnInit, OnChanges {
  public entityId: number;

  entityIdDetails: EntityIdDetails;
  selectedDocuments: Document[];
  addSelectDocumentForm: FormGroup;
  selectedAgreementId: any;

  selectedDocumentType: string;
  documentTypes: ApplicationValue[];
  documentLabels = [];
  users: User[];
  countries = [];
  fileEvent: any;
  loginUser: string;
  fileName: string;
  isRequestBeingProcessed = false;
  isAssociatedDocumentsListUpdated = false;

  arrEntityDocuments: SelectItem[];
  selectedDocumentsListBox = [];

  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private transactionProfileService: EntityTransactionProfileService,
    private trackingService: TrackingService,
    private snackBarService: SnackBarService,
    private entityDocumentsService: EntityDocumentsService,
    private warmUpService: WarmUpService,
    private entityDetailsService: EntityDetailsService,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    this.entityId = this.entityIdDetails.entityId;
    this.fillDocumentListboxValues();
    this.buildForm();
    this.loadDocumentTypes(this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE));
    this.loadCountries();
    this.loginUser = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
  }

  buildForm() {
    this.addSelectDocumentForm = this.formBuilder.group({
      documentDescription: [''],
      documentType: [''],
      docName: [''],
      selectedLabels: [[]],
      startDate: [''],
      endDate: [''],
      passportNumber: [''],
      validFrom: [''],
      validTo: [''],
      issuedBy: [''],
      verifiedBy: [''],
      certifiedBy: [''],
      documentsList: []
    });
    this.entityDocumentsService.getDocumentLabels().subscribe(
      response => {
        for (const labelObj of response.arrResult['values']) {
          this.documentLabels.push({ label: labelObj.name, value: { id: labelObj.id, name: labelObj.name } });
        }
      }
    );
    this.users = this.warmUpService.getUsersList();
    this.onValueChanged();
    this.ngOnChanges();
    this.addSelectDocumentForm.valueChanges.subscribe(data => this.onValueChanged(data));
  }

  ngOnChanges() {
    this.loadDocumentTypes(
      this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE)
    );
  }

  selectedDocumentsForAgreement() {
    if (this.selectedDocuments) {
      for (const selectedDocument of this.selectedDocuments) {
        if (selectedDocument.id) {
          this.selectedDocumentsListBox.push(selectedDocument.id);
        }
      }
      this.addSelectDocumentForm.patchValue({
        documentsList: this.selectedDocumentsListBox,
      });
    }
  }

  loadCountries() {
    const setCountries = (values) => { this.countries = values }
    this.warmUpService.getApplicationValueList(ApplicationTypeConstants.COUNTRY_TYPE, setCountries);
  }

  fillDocumentListboxValues() {
    const formattedEntityDocs = [];
    this.entityDocumentsService.listDocuments(this.entityId, 0)
      .subscribe(response => {
        for (const argFetchedDocRecord of response.arrResult) {
          if (argFetchedDocRecord.name) {
            formattedEntityDocs.push(
              {
                'label': argFetchedDocRecord.name,
                'value': argFetchedDocRecord.id,
              });
          }
        }
        this.arrEntityDocuments = formattedEntityDocs;
        this.selectedDocumentsForAgreement();
      }, err => {
        this.callDocUploadSnackBarService(err, '');
      }
      );
  }

  loadDocumentTypes(documentTypeValues: any) {
    if (documentTypeValues instanceof Observable) {
      documentTypeValues.subscribe(
        response => {
          this.warmUpService.setApplicationTypeInLS(response);
          this.documentTypes = response.values;
        }
      );
    } else {
      this.documentTypes = documentTypeValues;
    }
  }

  documentTypeChange(documentId: number) {
    const selectedDocument = this.getSelectedDocument(documentId);
    if (selectedDocument) {
      this.selectedDocumentType = selectedDocument.name;
      this.addSelectDocumentForm.reset();
      this.addSelectDocumentForm.patchValue({
        documentsList: this.selectedDocumentsListBox,
      });
    }
    this.cdr.detectChanges();
  }

  getSelectedDocument(documentId: number) {
    return this.documentTypes.find(document => document.id === documentId);
  }

  onValueChanged(data?: any) {
    if (!this.addSelectDocumentForm) {
      return;
    }
    FormErrors('addSelectDocumentForm', this);
  }

  onSubmit({ value, valid }): void {
    this.isRequestBeingProcessed = true;
    if (this.addSelectDocumentForm.valid && this.fileEvent && this.fileEvent.target.files.length > 0) {
      this.uploadFile(value);
    } else {
      this.saveSelectedDocuments(value);
    }
  }

  saveSelectedDocuments(value) {
    this.transactionProfileService.saveAgreementDocument(this.selectedAgreementId, this.selectedDocumentsListBox)
      .subscribe(response => {
        this.callDocUploadSnackBarService(response, MessageService.ADDED_DOCUMENT_SUCCESS);
        this.selectedDocuments = null;
        if (response.flagResult) {
          this.dialogRef.close(response);
        }
      });
  }

  documentFileUploadChange(event) {
    if (event.target.files.length > 0) {
      this.fileEvent = event;
      this.fileName = event.target.files[0].name;
    }
  }

  uploadFile(value) {
    const fileList: FileList = this.fileEvent.target.files;
    const xhr =
      this.transactionProfileService.uploadDocumentForAgreement(
        fileList, this.entityId, this.selectedAgreementId);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          let response = false;
          let documentIds = [];
          if (xhr.response) {
            response = JSON.parse(xhr.response).flagResult;
            documentIds = JSON.parse(xhr.response).arrResult;
            if (documentIds.length > 0) {
              this.updateDocumentData(documentIds, value);
              this.selectedDocumentsListBox = this.selectedDocumentsListBox.concat(documentIds);
            } else if (response) {
              this.callDocUploadSnackBarService(JSON.parse(xhr.response), MessageService.ADDED_DOCUMENT_SUCCESS);
              this.dialogRef.close(response);
            } else {
              this.callDocUploadSnackBarService(JSON.parse(xhr.response), '');
            }
          } else {
            this.callDocUploadSnackBarService(JSON.parse(xhr.response), '');
          }
        }
        this.callDocUploadSnackBarService(JSON.parse(xhr.response), '');
      }
    };
  }

  updateDocumentData(documentIds, value) {
    const documents = this.createDocumentsForDocumentIds(documentIds, value)
    this.entityDocumentsService.addDocument(documents)
      .subscribe(response => {
        this.saveSelectedDocuments(value);
      }, err => {
        this.callDocUploadSnackBarService(err, '');
      });
  }

  createDocumentsForDocumentIds(documentIds, value) {
    const documents = new Array();
    documentIds.forEach(documentId => {
      const document = new Document();
      document.dateOfUpload = new Date();
      document.entityId = this.entityId;
      document.validFrom = value.validFrom;
      document.validTo = value.validTo;
      document.type = value.documentType;
      document.docOwner = this.loginUser;
      if (value.selectedLabels && value.selectedLabels.length > 0) {
        for (const label of value.selectedLabels) {
          document.labels[label.id] = label.name;
        }
      }
      document.id = documentId;
      if (this.selectedDocumentType === 'Passport') {
        document.allMeta['passportNumber'] = value.passportNumber;
        document.allMeta['issuedBy'] = value.issuedBy;
        document.allMeta['verifiedBy'] = value.verifiedBy;
        document.allMeta['validFrom'] = value.validFrom;
        document.allMeta['validTo'] = value.validTo;
        document.allMeta['certifiedBy'] = value.certifiedBy;
      } else if (this.selectedDocumentType === 'Indemnity Agreement'
        || this.selectedDocumentType === 'Service Agreement') {
        document.allMeta['startDate'] = value.startDate;
        document.allMeta['endDate'] = value.endDate;
      } else {
        document.allMeta['otherDetails'] = value.documentDescription;
      }
      documents.push(document);
    });
    return documents;
  }

  callDocUploadSnackBarService(response: any, successMsg) {
    this.isRequestBeingProcessed = false;
    this.snackBarService
      .showStatus(response,
      successMsg,
      MessageService.DOCUMENT_FAILURE);
  }

  closeDialog(): void {
    this.addSelectDocumentForm.reset();
    this.dialogRef.close();
  }

  onDocumentListChange() {
    this.selectedDocumentsListBox = this.addSelectDocumentForm.get('documentsList').value;
    this.isAssociatedDocumentsListUpdated = true
  }

  isSaveDisabled() {
    return !(this.addSelectDocumentForm.valid && this.fileName || this.isAssociatedDocumentsListUpdated) || this.isRequestBeingProcessed;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/documents/adddocument/add-document.component.ts